import { brightnessFromColor } from 'utils'

export function textColorFromBackgroundColor(backgroundColor: string, defaultColor: string = '#fff'): string {
    const brightness = brightnessFromColor(backgroundColor)
    return brightness > 0.5 ? '#000' : defaultColor
}
